import React from "react";

import { Card } from "Common/Card/";

export const LoadingContainer = () => (
  <Card theme="elevated" className="plan-card loading">
    <div className="loading-text"> Loading Plans...</div>
  </Card>
);
